module.exports = __webpack_public_path__ + "static/media/actrol.f86bf90d.svg";